import React from 'react';
import { Sun, Moon, CloudSun, CloudMoon, Cloud, CloudRain, CloudFog, Snowflake, Zap, Wind, Droplets } from 'lucide-react';

const ICONS = {
  sun: Sun, moon: Moon, 'cloud-sun': CloudSun, 'cloud-moon': CloudMoon, cloud: Cloud,
  'cloud-rain': CloudRain, 'cloud-fog': CloudFog, snowflake: Snowflake, zap: Zap,
};

export default function WeatherCard({ data, loading }) {
  if (loading) {
    return (
      <div className="puvio-card p-5" data-testid="weather-card-skeleton">
        <div className="puvio-skeleton h-6 w-32 mb-3" />
        <div className="flex items-end justify-between">
          <div className="puvio-skeleton h-12 w-28" />
          <div className="puvio-skeleton h-14 w-14 rounded-full" />
        </div>
        <div className="puvio-skeleton h-4 w-48 mt-4" />
      </div>
    );
  }
  if (!data) return null;
  const Icon = ICONS[data.symbol?.icon] || Cloud;
  const temp = data.temp_c != null ? Math.round(data.temp_c) : '—';
  const hi = data.hi_c != null ? Math.round(data.hi_c) : null;
  const lo = data.lo_c != null ? Math.round(data.lo_c) : null;
  const wind = data.wind_ms != null ? Math.round(data.wind_ms * 3.6) : null;
  const isDay = data.symbol?.is_day !== false;

  return (
    <div className="puvio-card p-5 puvio-card-interactive" data-testid="weather-card">
      <div className="flex items-start justify-between">
        <div>
          <p className="font-bold text-[11px] uppercase tracking-[0.22em] text-[var(--puvio-mint-deep)]" data-testid="weather-label">Weather</p>
          <p className="text-xs text-[var(--puvio-text-2)] mt-0.5 font-medium">{data.symbol?.label || '—'}</p>
        </div>
        <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: isDay ? 'linear-gradient(135deg,#FFF1C2,#FFD66B)' : 'linear-gradient(135deg,#EAEEF7,#CBD5EC)' }}>
          <Icon className={`w-6 h-6 ${isDay ? 'text-[#B85F31]' : 'text-[#0F1A13]'}`} />
        </div>
      </div>
      <div className="mt-2 flex items-end gap-2">
        <span className="font-display text-5xl font-extrabold tracking-tight text-[#0F1A13]" data-testid="weather-temp">{temp}°</span>
        <span className="text-sm text-[var(--puvio-text-2)] font-bold mb-2">C</span>
      </div>
      {hi != null && lo != null && (
        <p className="text-[11px] text-[var(--puvio-text-2)] font-semibold">H {hi}°  ·  L {lo}°</p>
      )}
      <div className="mt-3 grid grid-cols-2 gap-2 text-[11px]">
        <div className="flex items-center gap-1.5 text-[var(--puvio-text-2)] font-semibold"><Droplets className="w-3.5 h-3.5" /> {data.humidity ?? '—'}%</div>
        <div className="flex items-center gap-1.5 text-[var(--puvio-text-2)] font-semibold"><Wind className="w-3.5 h-3.5" /> {wind ?? '—'} km/h</div>
      </div>
    </div>
  );
}
